import logoAutex from '../img/autex_rojo.png';
import logoApymsa from '../img/APYMSA 2020-.png';
import logoDefault from '../img/autex_rojo.png';

export const ORIGEN_ID = {
  APYMSA: 4,
  CRM: 9,
  EPICO: 16,
};

export const ORIGEN_CONFIG = {
  [ORIGEN_ID.APYMSA]: {
    logo: logoApymsa,
    backUrl: process.env.REACT_APP_APYMSA_CART_URL,
    showBackButton: true,
  },

  [ORIGEN_ID.EPICO]: {
    logo: logoAutex,
    backUrl: '/', // Aún no esta implementando en epico
    showBackButton: false,
  },

  default: {
    logo: logoDefault,
    backUrl: '/',
    showBackButton: false,
  },
};